
function doLangSwitch () {
	let langSel = document.querySelector('.language-switcher-select');

	if(!langSel) {
		return;
	}

	langSel.addEventListener('change', function() {
		let urlVal = this.value;


		if(urlVal) {
			window.location.assign(urlVal);
		}

	});

	window.addEventListener('DOMContentLoaded', () => {
		doLangSwitch();
	});

}

export default doLangSwitch;




